document.addEventListener('DOMContentLoaded', () => {
    const closeButton = document.querySelector('.side-event .close');
    const closedText = document.querySelector('.side-event .closed-text');
    const eventContent = document.querySelector('.events-block__blockcontent--post');

    const isEventClosed = localStorage.getItem('eventClosed') === 'true';

    if (isEventClosed) {
        eventContent.style.display = 'none';
        closeButton.style.display = 'none';


        closedText.style.display = 'block';
        closedText.style.opacity = '1';
        closedText.style.transition = 'none';
    } else {

        closedText.style.display = 'none';
    }

    closeButton.addEventListener('click', () => {
        eventContent.style.opacity = '0';
        eventContent.style.transition = 'opacity 0.5s';
        closeButton.style.display = 'none';

        localStorage.setItem('eventClosed', 'true');

        setTimeout(() => {
            eventContent.style.display = 'none';
            closedText.style.display = 'block';
            closedText.style.opacity = '0';
            closedText.style.transition = 'opacity 0.5s';
            setTimeout(() => {
                closedText.style.opacity = '1';
            }, 50);
        }, 500);
    });

    closedText.addEventListener('click', () => {
        closedText.style.opacity = '0';
        closedText.style.transition = 'opacity 0.5s';

        localStorage.removeItem('eventClosed');

        setTimeout(() => {
            closedText.style.display = 'none';
            eventContent.style.display = 'block';
            eventContent.style.opacity = '0';
            eventContent.style.transition = 'opacity 0.5s';
            setTimeout(() => {
                eventContent.style.opacity = '1';
                closeButton.style.display = 'flex';
            }, 50);
        }, 500);
    });
});